import { BackIcon, BrandIcon, CreatorIcon } from "Components/icons/Icons";
import React from "react";
import ModalTitle from "../common/ModalTitle";
import ModalCloseButton from "../common/ModalCloseButton";
import ModalDecorations from "./ModalDecorations";
import ModalDialog from "../common/ModalDialog";
import ModalContent from "../common/ModalContent";
import ModalHeader from "../common/ModalHeader";
import ModalBody from "../common/ModalBody";
import ModalFooter from "../common/ModalFooter";

export default function LoginOptions({ setModalType, setLogInOptions, setRole, setSignUpOptions }) {
  return (
    <ModalDialog className="tw-max-w-[926px]">
      <ModalContent>
        <ModalHeader className="sm:tw-pt-[50px] tw-border-none">
          <ModalCloseButton
            id="logIn-modal-close"
            onClose={() => {
              setSignUpOptions(false)
            }}
          />
          <ModalTitle text="Login in as" />
          <br className="tw-block sm:tw-hidden" />
          <p
            className="tw-block sm:tw-hidden tw-w-full
             tw-font-normal 
             tw-text-[14px] tw-leading-[140%] 
             tw-text-[#4B5463]"
          >
            Let’s get you set up in just a few steps.<br />
            Choose the option that best describes you to begin.
          </p>
        </ModalHeader>
        <ModalBody className="tw-flex-col-reverse">
          {/* Brand */}
          <div className="brand-signup-col
          tw-w-full sm:tw-w-auto
          ">
            {/* desktop */}
            <img className="
            brand-signup-logo
            tw-hidden sm:tw-block
            "
              src="/assets/images/brand_signup_logo.png" alt=".." />
            <div className="emptyVerticalSpace
             tw-hidden sm:tw-block
            "></div>
            <button
              className="tw-show-desktop
              tw-btn-gradient
              !tw-px-[18px] !tw-py-[20px]
              tw-w-[60%] tw-m-auto
              "
              type="button"
              onClick={() => {
                setModalType("logInFields");
                setLogInOptions(false);
                setRole(2);
              }}
            >
              Brand login
            </button>

            {/* mobile */}
            <div
              className="
              tw-flex sm:tw-hidden tw-relative
              tw-box-border
              tw-flex-col tw-justify-center tw-items-center
              tw-px-4 tw-pt-8 tw-pb-4
              tw-gap-3
              tw-isolate
              tw-bg-[rgba(255,255,255,0.4)]
              tw-border tw-border-white
              tw-shadow-[0px_4px_60px_rgba(120,200,202,0.05),0px_4px_40px_rgba(148,243,200,0.05)]
              tw-backdrop-blur-[25px]
              tw-rounded-[16px]"
              type="button"
              onClick={() => {
                setModalType("logInFields");
                setLogInOptions(false);
                setRole(2);
              }}
            >
              {/* Brand login */}
              <BrandIcon />
              <h5 className="modal-title text-center 
              tw-absolute tw-bottom-4
          --tw-font-['Suisse_Intl'] tw-font-medium tw-text-[24px] tw-leading-[140%] tw-text-[#2C323A]
          tw-m-auto
          ">Brand</h5>
            </div>
          </div>

          {/* Divider */}
          <div className="divider-column
          tw-hidden sm:tw-block
          ">
            <div className="verticalLine"></div>
            <p className="divider-text">Or</p>
            <div className="verticalLine"></div>
          </div>

          {/* Creator */}
          <div className="creator-signup-col
          tw-w-full sm:tw-w-auto
              tw-mb-8 sm:tw-mb-0
          ">

            {/* desktop */}
            <div className="creator-signup-background 
            tw-hidden sm:tw-block">
              <img className="creator-signup-logo" src="/assets/images/creator_signup_logo.png" alt=".." />
            </div>
            <div className="emptyVerticalSpace
            tw-hidden sm:tw-block
            "></div>
            <button
              className="tw-show-desktop
              tw-text-[16px]
              tw-bg-white tw-shadow-[5px_7px_17px_rgba(0,94,147,0.08)] tw-rounded-[30px] tw-font-medium tw-leading-[21px] tw-tracking-[0.03em] tw-text-[#63abad] tw-border tw-border-[#63abad] tw-px-[18px] tw-py-[20px] tw-transition-all tw-duration-400 tw-cursor-pointer
              tw-w-[60%] tw-m-auto
              "
              type="button"
              onClick={() => {
                setModalType("logInFields");
                setLogInOptions(false);
                setRole(1);
              }}
            >
              Creator Login
            </button>

            {/* mobile */}
            <div
              className="
                tw-flex sm:tw-hidden tw-relative         
                tw-box-border
                tw-flex-col tw-justify-center tw-items-center
                tw-px-4 tw-pt-8 tw-pb-4
                tw-gap-3
                tw-isolate
                tw-bg-[rgba(255,255,255,0.4)]
                tw-border tw-border-white
                tw-shadow-[0px_4px_60px_rgba(120,200,202,0.05),0px_4px_40px_rgba(148,243,200,0.05)]
                tw-backdrop-blur-[25px]
                tw-rounded-[16px]
  "
              type="button"
              onClick={() => {
                setModalType("logInFields");
                setLogInOptions(false);
                setRole(1);
              }}
            >
              {/* Creator Login */}
              <CreatorIcon />
              <h5 className="modal-title text-center
               tw-absolute tw-bottom-4
          --tw-font-['Suisse_Intl'] tw-font-medium tw-text-[24px] tw-leading-[140%] tw-text-[#2C323A]
          tw-m-auto
          ">Creator</h5>
            </div>
          </div>

          {/* Decorations */}
          <ModalDecorations type="loginInAs" />
        </ModalBody>

        <ModalFooter>
        </ModalFooter>
      </ModalContent>
    </ModalDialog>
  );
}
